export const configurablePermissionTypes = [
  'analytics-viewer',
  'audit-viewer',
  'load-creator',
  'load-booker',
  'load-canceler',
  'load-file-manager',
  'load-exporter',
  'manage-addresses',
  'manage-bill-to',
  'manage-branding',
  'manage-carriers',
  'manage-contracted-rates',
  'manage-gl-codes',
  'manage-locations',
  'manage-products',
  'manage-quote-filters',
  'manage-spot-contacts',
  'manage-settings',
  'manage-subscription',
  'manage-tags',
  'manage-users',
  'manage-vendors',
] as const
const nonConfigurablePermissionTypes = ['view-rates'] as const
export const userPermissionTypes = [
  ...configurablePermissionTypes,
  ...nonConfigurablePermissionTypes,
] as const

export type UserPermissionType = (typeof userPermissionTypes)[number]

export const userAccessTypes = ['admin', 'standard', 'view-only'] as const
export type UserAccessType = (typeof userAccessTypes)[number]

export const defaultUserAccess: UserAccess = {
  type: 'standard',
  permissions: ['load-creator', 'load-booker'],
}

export interface UserAccess {
  type: UserAccessType
  permissions?: UserPermissionType[]
}
